module.exports = __webpack_public_path__ + "media/images/icons/hottopic-a5d167e4d2edc842395715ea262129d8.svg";